import { ReactElement } from 'react';

import { RedirectContainers, ResultAction } from '@cashier/cashier-model';

import { HiddenFormProvider } from '../contexts';
import { HiddenForm } from '../modules/hiddenForm';
import { PaymentProgress } from '../modules/paymentProgress/v3';
import { ProviderIframe } from '../modules/providerIframe';
import { PaymentProcessingConfigurator } from '../utils/paymentProcessingConfiguration';

interface PaymentProcessingProps {
  loadingPageUrl: string;
  resultAction: ResultAction;
  paymentMethod: {
    name: string;
    redirectContainer: RedirectContainers;
  };
  isWebView?: boolean;
}

export const PaymentProcessing = ({
  loadingPageUrl,
  resultAction,
  paymentMethod,
}: PaymentProcessingProps): ReactElement => {
  const { hiddenForm, providerIframe, paymentProgress } =
    PaymentProcessingConfigurator.configure({
      resultAction,
      paymentMethod,
      loadingPageUrl,
    });

  return (
    <HiddenFormProvider>
      {hiddenForm && <HiddenForm {...hiddenForm} />}

      {providerIframe && (
        <ProviderIframe {...providerIframe} defaultSize={600} />
      )}

      {!providerIframe && (
        <PaymentProgress {...paymentProgress} resultAction={resultAction} />
      )}
    </HiddenFormProvider>
  );
};
